import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.string.trim";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.split";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/** @jsx jsx */

/* eslint react/jsx-key: 0 */


import Highlight, { defaultProps } from 'prism-react-renderer';
import { jsx, Styled } from 'theme-ui';
import { usePrismTheme } from '~utils/theme';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var Code = function Code(_ref) {
  var children = _ref.children,
      outerClassName = _ref.className;

  var _ref2 = outerClassName ? outerClassName.replace(/language-/, '').split(' ') : ['text'],
      language = _ref2[0];

  var theme = usePrismTheme();
  return jsx(Highlight, _extends({}, defaultProps, {
    code: children.trim(),
    language: language,
    theme: theme
  }), function (_ref3) {
    var className = _ref3.className,
        style = _ref3.style,
        tokens = _ref3.tokens,
        getLineProps = _ref3.getLineProps,
        getTokenProps = _ref3.getTokenProps;
    return jsx(Styled.pre, {
      className: (outerClassName || '') + " " + className,
      style: style,
      "data-testid": "code"
    }, tokens.map(function (line, i) {
      return jsx("div", getLineProps({
        line: line,
        key: i
      }), line.map(function (token, key) {
        return jsx("span", _extends({}, getTokenProps({
          token: token,
          key: key
        }), {
          sx: {
            display: 'inline-block'
          }
        }));
      }));
    }));
  });
};

if (typeof Code !== 'undefined' && Code && Code === Object(Code) && Object.isExtensible(Code) && !Code.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Code, '__filemeta', {
    configurable: true,
    value: {
      name: "Code",
      filename: "node_modules/gatsby-theme-docz/src/components/Code/index.js"
    }
  });
}